import axios from "axios";

export const postUserManagerCompleteRegistration = async (email:string) => {
    return await axios({
		url: `/User/UserManagerCompleteRegistration`,
		method: "POST",
		data: JSON.stringify(email),
		headers: {"Content-Type": 'application/json'}
	});
}  